import React from "react";
import { Link } from "react-router-dom";
import { useLanguage, pick } from "@/contexts/LanguageContext";
import EditableText from "@/components/EditableText";
import grupXalucaLogo from "@/assets/grup-xaluca-logo.webp";

const BRAND_FIRST = { es: "Xaluca", en: "Xaluca", fr: "Xaluca" };
const BRAND_SECOND = { es: "Tours", en: "Tours", fr: "Tours" };
const TAGLINE = {
  es: "Especialistas en viajes por Marruecos",
  en: "Specialists in Moroccan journeys",
  fr: "Spécialistes des voyages au Maroc",
};

export const BrandMark = ({ inverted = false, className = "", compactHeader = false }) => {
  const { lang } = useLanguage();
  const ink = inverted ? "#FDFBF7" : "#2C2621";
  return (
    <Link
      to="/"
      data-testid="brand-mark"
      aria-label={`Xaluca Tours — ${pick(TAGLINE, lang)}`}
      className={`inline-flex ${compactHeader ? "shrink-0 gap-1.5 sm:gap-2.5" : "gap-2.5"} items-center group ${className}`}
      style={{ color: ink }}
    >
      <img
        src={grupXalucaLogo}
        alt="Xaluca"
        data-testid="brand-logo"
        className={`${compactHeader ? "h-8 sm:h-9 md:h-11" : "h-9 md:h-11"} w-auto object-contain shrink-0 transition-transform duration-300 group-hover:scale-105`}
      />
      {compactHeader && (
        <span
          data-testid="brand-mobile-title"
          className="inline-flex sm:hidden whitespace-nowrap font-serif-x text-[17px] leading-none tracking-[-0.02em]"
        >
          Xaluca Tours
        </span>
      )}
      <span className={`${compactHeader ? "hidden sm:inline-flex" : "inline-flex"} items-baseline gap-2`}>
        <EditableText
          slot="brand.first"
          defaults={BRAND_FIRST}
          multiline={false}
          className="font-serif-x text-2xl md:text-[28px] leading-none tracking-tight"
        />
        <span className="text-[#C16542] text-2xl md:text-[28px] leading-none">·</span>
        <EditableText
          slot="brand.second"
          defaults={BRAND_SECOND}
          multiline={false}
          className="font-serif-x text-2xl md:text-[28px] leading-none tracking-tight italic"
        />
      </span>
      <EditableText
        slot="brand.tagline"
        defaults={TAGLINE}
        multiline={false}
        data-testid="brand-tagline"
        className={`hidden ${compactHeader ? "xl:inline-flex" : "lg:inline-flex"} items-center gap-3 ml-3 pl-3 border-l text-[10.5px] tracking-[0.22em] uppercase whitespace-nowrap opacity-70`}
        style={{ color: ink, borderColor: `${ink}33` }}
      />
    </Link>
  );
};
